import { render } from "./corpARMoney.vue?vue&type=template&id=cf8d4be0"
import script from "./corpARMoney.vue?vue&type=script&lang=js"
export * from "./corpARMoney.vue?vue&type=script&lang=js"

import "./corpARMoney.vue?vue&type=style&index=0&id=cf8d4be0&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__